import clsx from 'clsx';
import {GroupFilterContext} from 'context/groupFilterContext';
import {useTranslation} from 'hooks/translations/useCustomTranslation';
import {useRouter} from 'next/router';
import React, {useContext, useEffect, useState} from 'react';

import {Theme, useMediaQuery} from '@mui/material';

import formatPrice from 'utils/formateHelpers/formatPrice';

import {palette} from 'styles/mui/scss';

import {Box, Progress, Typography} from 'components/basic-components';
import {CustomIcon} from 'components/basic-components/CustomIcon/CustomIcon';
import Modal from 'components/basic-components/Modal';

import CarFilter from '../CarFilter/CarFilter';
import {SortDropDown} from '../SortDropDown/SortDropDown';
import styles from './ResultBar.module.scss';

const ResultBar = () => {
  const [displayFilter, setDisplayFilter] = useState(false);
  const {t} = useTranslation(['reservation', 'carFilter']);
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
  const router = useRouter();

  const {visibleMaxPrice, visibleMinPrice, resultAmount, withPrice} =
    useContext(GroupFilterContext);

  console.log(visibleMaxPrice, visibleMinPrice);

  useEffect(() => {
    if (isDesktop) {
      setDisplayFilter(false);
    }
  }, [isDesktop]);

  const ResultInformationSection = () => {
    return (
      <Box sx={{width: '100%', display: 'flex'}}>
        <Typography
          sx={{
            lineHeight: '30px',
            marginRight: {xxs: '15px', md: '12px', xl: '15px'},
            fontSize: {xxs: '17px', md: '20px'},
            fontWeight: 700,
          }}
        >
          {resultAmount} {t('Angebote')}
        </Typography>
        {withPrice &&
        visibleMaxPrice &&
        visibleMaxPrice !== Infinity &&
        visibleMinPrice &&
        visibleMinPrice !== Infinity &&
        resultAmount ? (
          <Typography
            sx={{
              fontSize: {xxs: '17px', md: '20px'},
              lineHeight: '30px',
              color: palette.colorGrey60,
            }}
          >
            {formatPrice(visibleMinPrice, router.locale)} € -{' '}
            {formatPrice(visibleMaxPrice, router.locale)} €
          </Typography>
        ) : !resultAmount || !withPrice ? null : (
          <Box sx={{display: 'flex', alignItems: 'center'}}>
            <Progress width="25" strokeColor={palette.colorBlack} />
          </Box>
        )}
      </Box>
    );
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          rowGap: '15px',
          alignItems: 'center',
        }}
        data-testid="resultbar"
      >
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          <button
            className={clsx({[styles.filterButton]: true, [styles.active]: router.query.filter})}
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <CustomIcon name="filter" style={{height: '24px', width: '24px', marginRight: '5px'}} />
            <Typography sx={{fontWeight: 700, lineHeight: '24px'}}>
              {t('filter', {ns: 'carFilter'})}
            </Typography>
          </button>
          <Box sx={{display: {xxs: 'none', md: 'flex'}, alignItems: 'center'}}>
            <ResultInformationSection />
          </Box>
        </Box>

        {withPrice ? (
          <Box>
            <SortDropDown />
          </Box>
        ) : null}
        <Box
          sx={{
            display: {xxs: 'flex', md: 'none'},
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <ResultInformationSection />
        </Box>
      </Box>
      <Box sx={{display: {xl: 'none'}}}>
        <Modal open={displayFilter}>
          <Box
            sx={{
              width: '100%',
              height: '100%',
              backgroundColor: 'white',
              overflow: 'auto',
            }}
          >
            <Box sx={{padding: '0 3%'}}>
              <Box
                sx={{
                  display: {xxs: 'flex', xl: 'none'},
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '25px 0',
                  position: 'sticky',
                  top: '0',
                  backgroundColor: palette.colorWhite,
                  zIndex: 1,
                }}
              >
                <ResultInformationSection />
                <CustomIcon
                  onClick={() => setDisplayFilter(!displayFilter)}
                  name="close"
                  style={{
                    display: displayFilter ? 'block' : 'none',
                    height: '24px',
                    width: '24px',
                    flexShrink: 0,
                    cursor: 'pointer',
                  }}
                />
              </Box>
              <Box sx={{display: {xxs: 'block', xl: 'none'}, position: 'relative'}}>
                <CarFilter setDisplayFilter={setDisplayFilter} />
              </Box>
            </Box>
          </Box>
        </Modal>
      </Box>
    </>
  );
};
export default ResultBar;
